import { createAction, props } from '@ngrx/store';
import { DialogData } from '../../components/zeiterfassung-formdialog-neu/zeiterfassung-formdialog-neu.component';

export const loadIstZeitStart = createAction('ZEIT::LOAD_ISTZEIT_START', props<{ datum: string }>());
export const loadIstZeitSucceeded = createAction(
  'ZEIT::LOAD_ISTZEIT_SUCCEEDED',
  props<{ zeit: number[]}>(),
);
export const loadIstZeitFailed = createAction('ZEIT::LOAD_ISTZEIT_FAILED',
  props<{ error: Error }>());
